module.exports = __webpack_public_path__ + "img/forBarna3.637941fb.png";